module.exports = __webpack_public_path__ + "img/boxThree.70eaf672.png";